import { render } from "./MypageTop.vue?vue&type=template&id=3f38c35a&ts=true"
import script from "./MypageTop.vue?vue&type=script&lang=ts"
export * from "./MypageTop.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__